export default {
  modal: state => state.modal
}